import { Box, Button, styled } from "@mui/material";
import AuthenticateLayout from "../../components/AuthenticateLayout";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Loading } from "../../components";
import { useTranslation } from "react-i18next";
import { ENV } from "../../configs/env";
import ChangeLanguage from "../../components/ChangeLanguage";


const AlertTitle = styled(Button)({
  justifyContent: "center",
  backgroundColor: "rgba(17, 85, 170, 0.1)",
  color: "#1155AA",
  fontSize: 28,
  fontWeight: 500,
  pointerEvents: "none",
});

const AlertMessage = styled(Button)({
  marginTop: 20,
  justifyContent: "center",
  color: "#1155AA",
  fontSize: 16,
  fontWeight: 500,
  paddingInline: 18,
  textAlign: "center",
  lineHeight: "20px",
  pointerEvents: "none",
});


const CAMPAIGN_LIMIT_ERROR = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const advertiser_banner = location.state?.advertiser_banner;
  const banner_image_corner = location.state?.banner_image_corner;
  const limit_engage_type = location.state?.limit_engage_type;
  const [isLoading, setIsLoading] = useState(false);


  return (
    <>
      {(isLoading && <Loading />) && <Loading customBackgroundColor="rgba(255,255,255,1)" />}
      <AuthenticateLayout
        button={() => !ENV.HIDE_TRANSLATOR && <ChangeLanguage />}
        isLoading={isLoading}
        background={advertiser_banner}
        bannerImageCorner={banner_image_corner}
        hideLogo={ENV.HIDE_LOGO}
      >
        <Box
          px={2.5}
          mt={6}
          pb={21}
          display="flex"
          justifyContent="center"
          flexDirection="column"
        >
          {
            <>
              <AlertTitle fullWidth variant="contained">
                {t("youAreLate")}
              </AlertTitle>
            </>
          }
          <Box display="flex" justifyContent="space-between">
            <AlertMessage fullWidth>
              {t("campaignLimitError").replace("{limit_engage_type}", t(limit_engage_type)) }
            </AlertMessage>
          </Box>
        </Box>
      </AuthenticateLayout>
    </>
  );
};

export default CAMPAIGN_LIMIT_ERROR;
